// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"HomeFeedResults-f4f03ba8b0f441cb"};